var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { cx } from 'emotion';
/**
 * A Component implementing a card with internal tabs in the header
 */
const TabCard = (_a) => {
    var { selectedIndex, onSelect, tabs, className, style } = _a, rest = __rest(_a, ["selectedIndex", "onSelect", "tabs", "className", "style"]);
    const initialSelectedIndex = selectedIndex > 0 ? selectedIndex : 0;
    const [localSelectedIndex, setLocalSelectedIndex] = useState(initialSelectedIndex);
    const onTabSelect = (e, selectedKey) => {
        e.preventDefault();
        setLocalSelectedIndex(selectedKey);
        if (onSelect) {
            onSelect(e, selectedKey);
        }
    };
    useEffect(() => {
        if (selectedIndex >= 0) {
            setLocalSelectedIndex(selectedIndex);
        }
    }, [setLocalSelectedIndex, selectedIndex]);
    const renderTab = (tabInfo, tabIndex) => (React.createElement("li", { key: tabIndex, className: cx('nav-item', { active: tabIndex === localSelectedIndex }) },
        React.createElement("a", { href: tabInfo.href || null, className: "nav-link", onClick: e => onTabSelect(e, tabIndex) },
            React.createElement("strong", null,
                " ",
                tabInfo.name,
                " "))));
    const renderTabNav = () => React.createElement("ul", { className: "nav card-tab-nav" },
        " ",
        tabs.map(renderTab),
        " ");
    const renderFooter = () => {
        if (tabs[localSelectedIndex].footer) {
            return React.createElement("div", { className: "card-footer" },
                " ",
                tabs[localSelectedIndex].footer,
                " ");
        }
        return null;
    };
    return (React.createElement("div", Object.assign({ className: cx('card tab-card', className), style: style }, rest),
        React.createElement("div", { className: "card-header card-tabs" }, renderTabNav()),
        React.createElement("div", { className: "card-block" }, tabs[localSelectedIndex].block),
        renderFooter()));
};
TabCard.propTypes = {
    className: PropTypes.string,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.node.isRequired,
        block: PropTypes.node.isRequired,
        footer: PropTypes.node,
        href: PropTypes.string,
    })),
    onSelect: PropTypes.func,
    selectedIndex: PropTypes.number,
    style: StylePropType,
};
TabCard.defaultProps = {
    className: '',
    tabs: [],
    onSelect: () => { },
    selectedIndex: undefined,
    style: {},
};
export default TabCard;
